import React from "react";
import Profile from "../features/myprofile/Profile";

const ProfilePage: React.FC = () => {
  return <Profile />;
};

export default ProfilePage;